<template>
  <v-card class="ma-0">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Settings</v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col cols="12">
          <label for="">Color</label>
          <v-color-picker @update:color="onColorChange" label="Color" flat hide-canvas hide-inputs hide-mode-switch
            @change="storeToLocal" class="mt-2" show-swatches :value="form.sales_pdf_report_settings.textColor" />
          {{ form.sales_pdf_report_settings.textColor }}
        </v-col>
        <v-col cols="12">
          <v-btn color="primary" @click="save" block>Save</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from '@/extra-functions/axios.extra'
import LocalStore from '@/lib/localStore'
import { ErrorPopup, SuccessPopup, camelToSnake, LoadingPopup } from '@/lib/utils'

const defaultForm = () => ({
  sales_pdf_report_settings: {
    textColor: '#000000',
  },
})

const localStore = new LocalStore({
  schema: {
    createSetting: {
      ...defaultForm(),
      unsavedChanges: false,
    },
  },
})

export default {
  name: 'CreateSetting',
  props: {
    // Define any props if needed
    stockBrandTypeId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      form: defaultForm(),
      validationErrors: {},
    }
  },
  created() {
    this.getLocalData()
    if (this.stockBrandTypeId) {
      this.fetchData()
    }
  },
  watch: {
    stockBrandTypeId(newId) {
      this.fetchData()
    },
  },
  methods: {
    async save() {
      try {
        const payload = this.toSnakeCase(this.form)
        await axios(this.$store.state.auth.token).put(`stock-brand-types/${this.stockBrandTypeId}/settings`, payload)
        this.reset()
        this.$emit('created')
        SuccessPopup.fire({
          title: 'Setting Created',
          text: 'The setting has been successfully created.',
        })
      } catch (e) {
        if (e?.response?.data?.errors) {
          this.validationErrors = { ...e.response.data.errors }
          return
        }
        ErrorPopup.fire('Failed to update settings.')
      }
    },
    async fetchData() {
      try {
        LoadingPopup.fire('Loading setting data...')
        const { data } = await axios(this.$store.state.auth.token).get(`stock-brand-types/${this.stockBrandTypeId}/settings/edit`)

        this.form = { ...data, sales_pdf_report_settings: data.sales_pdf_report_settings }
        LoadingPopup.close()
      } catch (error) {
        console.error(error)
        ErrorPopup.fire('Failed to load setting data.')
      }
    },
    storeToLocal() {
      localStore.set({
        createSetting: {
          ...this.form,
          unsavedChanges: true,
        },
      })
    },
    getLocalData() {
      const saved = localStore.get('createSetting')
      if (saved?.unsavedChanges) {
        this.form = { ...saved }
      }
    },
    reset() {
      this.form = defaultForm()
      this.validationErrors = {}
      localStore.delete('createSetting')
    },
    toSnakeCase(obj) {
      return Object.keys(obj).reduce((acc, key) => {
        acc[camelToSnake(key)] = obj[key]
        return acc
      }, {})
    },
    onColorChange(color) {
      this.form = { ...this.form, sales_pdf_report_settings: { ...this.form.sales_pdf_report_settings, textColor: color.hex } }
      this.storeToLocal()
    },
  },
}
</script>

<style scoped>
.v-card {
  margin: 2rem auto;
  max-width: 400px;
}
</style>
